// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__20ZF3","image":"Header_image__3iY2w","name":"Header_name__1zudj","info":"Header_info__2cUtD","infoRow":"Header_infoRow__2lrNI"};